export interface StickyNote {
  id: string;
  content: string;
  color: string;
  author?: string;
  timestamp: Date;
  x?: number;
  y?: number;
  column: string;
}

export interface BoardColumn {
  id: string;
  title: string;
  color: string;
  placeholder?: string;
  notes: StickyNote[];
}

export interface ActionItem {
  id: string;
  title: string;
  description?: string;
  assignee?: string;
  priority: 'low' | 'medium' | 'high';
  status: 'pending' | 'in-progress' | 'completed';
  dueDate?: Date;
  createdFrom?: string; // noteId that generated this action
}

export interface RetrospectiveBoard {
  id: string;
  title: string;
  templateId: string;
  teamName?: string;
  teamId?: string;
  columns: BoardColumn[];
  actionItems: ActionItem[];
  createdAt: Date;
  updatedAt: Date;
  isArchived: boolean;
  shareableLink: string;
}

export interface RetrospectiveTemplate {
  id: string;
  name: string;
  description: string;
  columns: {
    id: string;
    title: string;
    color: string;
    placeholder: string;
  }[];
  preview?: string;
  isDefault: boolean;
}

export interface User {
  id?: string;
  name?: string;
  color: string;
  isAnonymous: boolean;
}

export interface SocketEvents {
  // Board events
  'join-board': { boardId: string; user: User };
  'leave-board': { boardId: string; userId?: string };
  'board-updated': { board: RetrospectiveBoard };
  
  // Note events
  'note-added': { boardId: string; note: StickyNote };
  'note-updated': { boardId: string; note: StickyNote };
  'note-deleted': { boardId: string; noteId: string };
  'note-moved': { boardId: string; noteId: string; fromColumn: string; toColumn: string; position: number };
  
  // Action events
  'action-added': { boardId: string; action: ActionItem };
  'action-updated': { boardId: string; action: ActionItem };
  'action-deleted': { boardId: string; actionId: string };
  
  // User events
  'user-joined': { user: User };
  'user-left': { userId?: string };
  'users-list': { users: User[] };
}

export type StickyNoteColor = 
  | 'sticky-yellow'
  | 'sticky-pink' 
  | 'sticky-green'
  | 'sticky-blue'
  | 'sticky-purple'
  | 'sticky-orange';

export const STICKY_COLORS: { name: StickyNoteColor; class: string; hex: string }[] = [
  { name: 'sticky-yellow', class: 'bg-sticky-yellow', hex: '#FFEB3B' },
  { name: 'sticky-pink', class: 'bg-sticky-pink', hex: '#E91E63' },
  { name: 'sticky-green', class: 'bg-sticky-green', hex: '#4CAF50' },
  { name: 'sticky-blue', class: 'bg-sticky-blue', hex: '#2196F3' },
  { name: 'sticky-purple', class: 'bg-sticky-purple', hex: '#9C27B0' },
  { name: 'sticky-orange', class: 'bg-sticky-orange', hex: '#FF9800' },
];

export interface ExportOptions {
  format: 'excel' | 'pdf' | 'json';
  includeActionItems: boolean;
  includeTimestamps: boolean;
  groupByColumn: boolean;
}